<template>
  <v-dialog
    v-model="vehicleFilterDialog"
    @submit="applyFilters()"
    @reset="resetFilters()"
    width="30%"
    ><v-card>
      <v-card-title>
        <v-row class="d-flex justify-space-between">
          <v-col cols="6">
            <h3 class="text-body-1 primary--text font-weight-bold">
              Vehicle Filter
            </h3>
          </v-col>
          <v-col cols="6" class="d-flex justify-end">
            <v-icon @click="vehicleFilterDialog = false" color="primary"
              >mdi-close</v-icon
            >
          </v-col>
        </v-row>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pa-4">
        <v-form ref="vehicleFilterForm">
          <v-row no-gutters>
            <v-col cols="12" md="12" lg="12" xl="12" class="">
              <BaseSelect
                dense
                hide-details
                outlined
                clearable
                label="Select Project"
                :itemsList="projectList"
                itemText="name"
                itemValue="value"
                :multiple="true"
                v-model="vehicleFilter.project_id"
                class="pl-1"
                :menu-props="{ offsetY: true }"
                @change="syncVehicleFilters('project_id', $event)"
              ></BaseSelect>
            </v-col>

            <v-col cols="12" md="6" lg="6" xl="6" class="py-2 pl-1">
              <BaseTextInput
                id="min_seat"
                name="min_seat"
                type="number"
                v-model="vehicleFilter.min_seat"
                @input="syncVehicleFilters('min_seat', $event)"
                label="Min Seat"
              ></BaseTextInput>
            </v-col>
            <v-col cols="12" md="6" lg="6" xl="6" class="py-2 pl-2">
              <BaseTextInput
                id="max_seat"
                name="max_seat"
                type="number"
                v-model="vehicleFilter.max_seat"
                @input="syncVehicleFilters('max_seat', $event)"
                label="Max Seat"
              ></BaseTextInput>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>

      <v-card-actions class="d-flex justify-end">
        <BaseSecondaryButton
          small
          customClass="rounded-lg"
          id="resetVehicleFilter"
          @click="resetFilters()"
          >Reset</BaseSecondaryButton
        >
        <BaseButton
          small
          customClass="rounded-lg"
          id="applyVehicleFilter"
          @click="applyFilters()"
          >Apply</BaseButton
        >
      </v-card-actions>
    </v-card></v-dialog
  >
</template>

<script>
export default {
  props: {
    value: Boolean,
  },
  data() {
    return {
      projectList: [],
      vehicleFilter: {},
    };
  },
  watch: {
    vehicleFilterDialog(value) {
      if (value) {
        this.getProjectsList();
        let filters = localStorage.getItem("vehicleFilters");
        if (!filters) {
          filters = {};
        }
        if (typeof filters == typeof "string") {
          filters = JSON.parse(filters);
        }
        this.vehicleFilter = filters;
      }
    },
  },
  computed: {
    vehicleFilterDialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    getProjectsList(params = {}) {
      params = {
        ...params,
        limit: "all",
      };
      this.$api.projects.getProjectList(params).then((res) => {
        this.projectList = res.data.map((obj) => {
          return {
            name: obj.project_name,
            value: obj.project_id,
          };
        });
      });
    },
    syncVehicleFilters(key, value) {
      let filters = localStorage.getItem("vehicleFilters");
      if (!filters) {
        filters = {};
      }
      if (typeof filters == typeof "string") {
        filters = JSON.parse(filters);
      }
      if (value !== null && value.length > 0) {
        filters[key] = value;
      } else {
        delete filters[key];
      }
      this.vehicleFilter = filters;
      localStorage.setItem("vehicleFilters", JSON.stringify(filters));
    },
    applyFilters(reload) {
      this.$emit("vehicleFiltersChanged");
      this.vehicleFilterDialog = false;
    },
    resetFilters(reload) {
      this.companyFilter = {};
      localStorage.removeItem("vehicleFilters");
      this.$emit("vehicleFiltersChanged");
      if (this.$refs.vehicleFilterForm) {
        this.$refs.vehicleFilterForm.reset();
      }
    },
  },
};
</script>

<style>
</style>